import { render, staticRenderFns } from "./GarmentMeasure.vue?vue&type=template&id=f05b4b16&scoped=true&"
import script from "./GarmentMeasure.vue?vue&type=script&lang=js&"
export * from "./GarmentMeasure.vue?vue&type=script&lang=js&"
import style0 from "./GarmentMeasure.vue?vue&type=style&index=0&id=f05b4b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05b4b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VContainer,VFlex,VLayout,VMenu})
